import React from "react";
import { MapPin } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto fade-up">
      <div className="bg-white border border-[#D2E0E6] rounded-2xl shadow-sm px-6 py-8 md:px-12 md:py-12 text-center fade-up" data-testid="welcome-hero">
        <img src="/qls-lettermark.png" alt="Quantum Leap Solutions logo" data-testid="hero-logo"
          className="h-20 md:h-24 w-auto mx-auto mb-4 object-contain" />
        <p className="text-lg md:text-2xl text-[#47616B] font-bold mb-2">Welcome to</p>
        <h1 className="gradient-text brand-font text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] mb-4">
          Quantum Leap Solutions
        </h1>
        <p className="text-lg md:text-2xl text-[#47616B] font-bold max-w-2xl mx-auto">
          Your leap to transformative analytics solutions.
        </p>
        <p className="text-sm md:text-base text-[#47616B] leading-relaxed max-w-3xl mx-auto mt-5">
          Quantum Leap Solutions partners with mid-market leaders and enterprise executives to transform
          complex data ecosystems into highly profitable business outcomes. Whether you're launching an
          analytics initiative from scratch, supplementing your existing team, or reinventing your analytics
          function, we deliver elite, project-based analytics expertise tailored to your exact business objectives.
        </p>
        <p className="text-sm md:text-base text-[#0B2830] font-semibold max-w-3xl mx-auto mt-3">
          25+ years of a proven track record delivering analytical solutions across small, mid-size, and
          Fortune 500 companies.
        </p>
        <div className="flex items-center justify-center gap-1.5 text-[#47616B] mt-6" data-testid="landing-location">
          <MapPin className="w-4 h-4 text-[#0D9488]" />
          <span className="text-sm font-medium">Nashville, TN</span>
        </div>
      </div>
    </div>
  );
}
